import React, { useState } from "react";
import { Grid } from "@material-ui/core";

import BaseInput from "../../../../../components/elements/BaseInput";
import Button from "../../../../../components/elements/Button";
import api from "../../../../../api";
import classes from "../../CampaignsDashboard.module.scss";
import { errorToaster } from "../../../../../helpers/toasters";

type LandingPageEditModeProps = {
  landingPage: string;
  changeMode: () => void;
  adGroupId: string | undefined;
  fetchAndSetCreatives: () => Promise<void>;
};

const updateLandingPage = async (adGroupId: string, landingPage: string) => {
  try {
    return await api.updateCreativesLandingPage(adGroupId, landingPage);
  } catch (error) {
    const err = error as any;
    throw new Error(err.message);
  }
};

const LandingPageEditMode = ({
  landingPage,
  changeMode,
  adGroupId,
  fetchAndSetCreatives,
}: LandingPageEditModeProps) => {
  const [inputValue, setInputValue] = useState<string>(landingPage);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  const handleSaveClick = async () => {
    try {
      if (adGroupId !== undefined) {
        setIsLoading(true);
        await updateLandingPage(adGroupId, inputValue);
        await fetchAndSetCreatives();
        setIsLoading(false);
        changeMode();
      }
    } catch (error) {
      const err = error as any;
      setIsLoading(false);
      errorToaster(`There was an error: ${err.message}`);
    }
  };

  return (
    <Grid className={classes.landingPageContainer}>
      <BaseInput value={inputValue} onChange={handleInputChange} variant="outlined" label="Landing Page" required />
      <Button onClick={handleSaveClick} isLoading={isLoading}>
        Save
      </Button>
      <Button variant="outlined" onClick={changeMode} disabled={!!isLoading}>
        Cancel
      </Button>
    </Grid>
  );
};

export default LandingPageEditMode;
